import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { CommissionSettingsService } from '../../services/commission-settings.service';
import { CAS_COMMISSION_LIST, normalizeCasCommission } from '../../constants/cas-commission';

@Component({
  selector: 'app-commission-settings',
  standalone: true,
  imports: [CommonModule, FormsModule, CardModule, DropdownModule, ToastModule],
  providers: [MessageService],
  templateUrl: './commission-settings.component.html',
  styleUrl: './commission-settings.component.css'
})
export class CommissionSettingsComponent implements OnInit {
  commissionLoading = false;
  /** Code CAS affiché : même clé localStorage que le tableau comparateur. */
  singleSelectedCode = '';
  /** Mêmes valeurs que la liste déroulante « Commission » du tableau CAS. */
  unifiedOptions: { label: string; value: string }[] = [];

  constructor(
    private commissionService: CommissionSettingsService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.unifiedOptions = CAS_COMMISSION_LIST.map((c) => ({ label: c, value: c }));
    this.loadCasCommission();
  }

  /** Affiche le taux CAS enregistré pour le comparateur (navigateur). */
  private pickCasCommissionFromStored(raw: string): string {
    if (!raw) {
      return '';
    }
    const n = normalizeCasCommission(raw.trim());
    if (n && CAS_COMMISSION_LIST.includes(n)) {
      return n;
    }
    return '';
  }

  loadCasCommission(): void {
    const raw = this.commissionService.getCasTableCommissionRaw();
    this.singleSelectedCode = this.pickCasCommissionFromStored(raw);
  }

  /** Enregistre le taux CAS (identique au tableau) — local uniquement, pas d’API CAC par partenaire. */
  saveCasCommission(): void {
    const v = (this.singleSelectedCode || '').trim();
    if (!v) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sélection vide',
        detail: 'Choisissez un taux dans la liste du comparateur CAS.'
      });
      return;
    }
    if (!CAS_COMMISSION_LIST.includes(v)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Taux non reconnu',
        detail: 'Utilisez une valeur de la liste CAS (format XX/XX).'
      });
      return;
    }
    this.commissionService.saveDefaultCode(v);
    this.messageService.add({
      severity: 'success',
      summary: 'Commission CAS enregistrée',
      detail: 'Ce taux sera utilisé par défaut dans le tableau du comparateur santé.'
    });
  }

  onDropdownChange(): void {
    const v = this.singleSelectedCode;
    if (v === null || v === undefined || String(v).trim() === '') {
      return;
    }
    this.saveCasCommission();
  }
}
